<template>
  <div class="community-basic-search">
    <div class="d-flex mb-3">
      <strong class="flex-fill">Pesquisar colaboradores</strong>
      <button @click="$emit('close')" class="btn text-light p-0">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- avoid autocomplete -->
    <form-group id="email" name="email" class="d-none" />

    <form-group
      v-model="searchTerm"
      placeholder="Buscar"
      id="search"
      name="search"
      disable-autocomplete
    />
    <action-dispatcher
      v-if="search"
      :key="search"
      action="community/getUsers"
      :parameters="{ search, limit: 20 }"
    >
      <div
        class="d-flex align-items-center cursor-pointer py-2"
        v-for="user in users"
        :key="user.id"
        @click="$emit('user', user)"
      >
        <img
          v-if="user.picture"
          :src="user.picture"
          class="rounded-circle img-fluid user-picture"
        />
        <img
          v-else
          src="@/assets/images/avatar.png"
          class="rounded-circle img-fluid user-picture"
        />
        <div class="fw-500">{{ user.name }}</div>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      searchTerm: "",
      search: "",
      timeout: null
    };
  },
  computed: {
    ...mapState("community", ["users"])
  },
  watch: {
    searchTerm() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.search = this.searchTerm;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.community-basic-search {
  .user-picture {
    max-width: 32px;
    max-height: 32px;
    min-width: 32px;
    min-height: 32px;
    margin-right: 8px;
  }
}
</style>
